export default {
    classes: {
        find_by_prefix: (element, prefix) => {
            if (!element) {
                return null;
            }

            return [...element.classList].find(cls => cls.startsWith(prefix));
        }
    },

    object: {
        is_object: (item) => typeof item === "object" && !Array.isArray(item) && item !== null
    }
};
